export const numeroCursos = [
  {
    name: "2017",
    Quantidade: 11259,
  },
  {
    name: "2018",
    Quantidade: 11473,
  },
  {
    name: "2019",
    Quantidade: 10889,
  },
  {
    name: "2020",
    Quantidade: 10878,
  },
  {
    name: "2021",
    Quantidade: 11005,
  },
];

export const numeroMatriculas = [
  {
    name: "2017",
    Quantidade: 1031798,
  },
  {
    name: "2018",
    Quantidade: 964593,
  },
  {
    name: "2019",
    Quantidade: 1023303,
  },
  {
    name: "2020",
    Quantidade: 1507476,
  },
  {
    name: "2021",
    Quantidade: 1523346,
  },
];

export const numeroPessoasPorEtnias = [
  {
    name: "2017",
    Amarelo: 6194,
    Branco: 167811,
    Indígena: 2700,
    Parda: 177571,
    Preta: 40387,
    "Não declarada": 57198,
  },
  {
    name: "2018",
    Amarelo: 10141,
    Branco: 155504,
    Indígena: 3455,
    Parda: 201775,
    Preta: 47363,
    "Não declarada": 86042,
  },
  {
    name: "2019",
    Amarelo: 7497,
    Branco: 200501,
    Indígena: 3466,
    Parda: 246809,
    Preta: 57147,
    "Não declarada": 58830,
  },
  {
    name: "2020",
    Amarelo: 15140,
    Branco: 420742,
    Indígena: 4121,
    Parda: 391274,
    Preta: 104908,
    "Não declarada": 64004,
  },
  {
    name: "2021",
    Amarelo: 11347,
    Branco: 340885,
    Indígena: 4205,
    Parda: 358582,
    Preta: 92831,
    "Não declarada": 72719,
  },
];
